
export const AddressMask = ({ address }: any) => {
  let _address
  if (!address || address === "" || address === "0x0") { address = "Unknown address" }
  else { _address = address.substr(0, 6) + '...' + address.substr(address.length - 4, 4) }
  return (<>
    { _address}
  </>)
}
